import { StyleSheet, View } from 'react-native';
import { CheckCircle } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import { AppText } from '../ui/AppText';

const stageSteps = [
  { key: 'image_uploading', label: '传图' },
  { key: 'vision', label: '识别' },
  { key: 'parser', label: '题意' },
  { key: 'solver', label: '讲解' },
  { key: 'done', label: '完成' },
] as const;

type PhotoSearchStageProgressProps = {
  currentStageKey: string;
  streamStatus: 'connecting' | 'streaming' | 'done' | 'error';
};

export function PhotoSearchStageProgress({
  currentStageKey,
  streamStatus,
}: PhotoSearchStageProgressProps) {
  const activeIndex = Math.max(
    0,
    stageSteps.findIndex((step) => step.key === currentStageKey)
  );
  const doneIndex = streamStatus === 'done' ? stageSteps.length - 1 : activeIndex;

  return (
    <View style={styles.stageProgress}>
      {stageSteps.map((step, index) => {
        const active = index <= doneIndex;
        return (
          <View key={step.key} style={styles.stageItem}>
            <View style={[styles.stageDot, active ? styles.stageDotActive : null]}>
              {active && streamStatus === 'done' && index === doneIndex ? (
                <CheckCircle size={13} color={tokens.colors.primary} />
              ) : null}
            </View>
            <AppText
              variant="caption"
              weight="semibold"
              tone={active ? 'primary' : 'subtle'}
              style={styles.stageLabel}
            >
              {step.label}
            </AppText>
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  stageProgress: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: tokens.spacing.sm,
  },
  stageItem: {
    flex: 1,
    alignItems: 'center',
  },
  stageDot: {
    width: 22,
    height: 22,
    borderRadius: 11,
    borderWidth: tokens.border.width,
    borderColor: tokens.colors.border,
    backgroundColor: tokens.colors.surface,
    alignItems: 'center',
    justifyContent: 'center',
  },
  stageDotActive: {
    borderColor: tokens.colors.primary,
    backgroundColor: tokens.colors.surfaceMuted,
  },
  stageLabel: {
    marginTop: tokens.spacing.xs,
  },
});
